import React from 'react';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType } from 'constants/enums/insType.enum';
import PolicyInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyInfo';
import InsuredContent from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredContent';
import PolicyholderInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PolicyholderInfo';
import InsuredInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/InsuredInfo';
import PaymentInfo from 'components/MemberCenter/PolicyInquiry/PolicyDetail/PaymentInfo';
import { IProps, IState } from './types';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';

class PolicyDetailTravel extends React.Component<IProps, IState> {
  state: IState = {
    detailInfo: {
      POLICY_DATA: {
        APPLY_NO: '',
        CONFLICT_STATUS: '',
        APPLY_TIME: '',
        BC_TYPE: '',
        DEPARTMENT: '',
        OPERATOR: '',
        PAYMENT_STATUS: '',
        POLICY_DELIVERY: '',
        POLICY_NO: '',
        POLICY_STATUS: '',
        PROGRAM_ID: '',
        IS_CERTEN: 'N'
      },
      POLICY_INFO: {
        DESTINATION_ID: new Array(0),
        INSURANCE_CERTIFICATE_EN: '',
        INS_PERIOD: '',
        PEOPLE: 0,
        PLAN_DESC: '',
        PRODUCT_NAME: '',
        SPI_ACTIVITY: '',
        TRANSPORT: ''
      },
      APPLICANT_DATA: {
        ADDRESS: {
          ADDRESS: '',
          AREA_ID: '',
          CITY_ID: '',
          FULL: '',
          POST_CODE: ''
        },
        BIRTHDAY: '',
        EMAIL: '',
        GENDER: '',
        ID: '',
        KYC_DATA: new Array(0),
        MOBILE: '',
        NAME: '',
        NATIVE: '',
        OCCUPATION: ''
      },
      INSURED_DATA: {
        DATA: new Array(0),
        TOTAL_FEE_INFO: ''
      },
      FLIGHT_DATA: {
        DATA: new Array(0),
        QUICK_CLAIM: ''
      },
      PAYMENT_DATA: {
        AMOUNT: 0,
        APPROVE_CODE: '',
        BANK: '',
        BANK_ACCOUNT: '',
        CARD_NO: '',
        PAYER_ID: '',
        PAYER_NAME: '',
        PAY_BY: '',
        TRANSACTION: ''
      },
      AVAILABLE_ACTION: {
        ACTIONS: new Array(0),
        ACTION_URL: ''
      },
      OPERATION_LOG: new Array(0)
    },
    insTypeId: ''
  }

  componentDidMount () {
    let detailInfoVal;
    let insTypeIdVal;
    if (this.props.history.location.state) {
      // 透過路由取得險種類別
      const { detailInfo, insTypeId }: any = this.props.history.location.state;
      detailInfoVal = detailInfo;
      insTypeIdVal = insTypeId;
    }
    // console.log('detailInfoVal', detailInfoVal);
    if (!detailInfoVal || !insTypeIdVal) {
      this.props.history.replace(RouterSettings.MemberCenter.PolicyInquiry);
      return;
    }

    this.setState({
      detailInfo: { ...detailInfoVal },
      insTypeId: insTypeIdVal
    });
  }

  render () {
    const { POLICY_INFO, POLICY_DATA, APPLICANT_DATA, INSURED_DATA, PAYMENT_DATA } = this.state.detailInfo;

    return (
      <div className={`policy-detail policy-detail--${InsTypeDefinesEN[InsType.Travel]}`}>
        <div className="template-container">
          <div className="template-content">
            <div className="policy-detail__content">
              {/* 保單資訊 */}
              {
                POLICY_DATA && (
                  <PolicyInfo {...POLICY_DATA} INS_TYPE_ID={this.state.insTypeId} />
                )
              }
              {/* 投保内容 */}
              {
                POLICY_INFO && (
                  <InsuredContent>
                    <InsuredContent.List
                      {...POLICY_INFO}
                      INS_TYPE_ID={this.state.insTypeId}
                    />
                  </InsuredContent>
                )
              }
              {/* 要保人資料 */}
              {
                APPLICANT_DATA && (
                  <PolicyholderInfo {...APPLICANT_DATA} ADDRESS={APPLICANT_DATA.ADDRESS.FULL} />
                )
              }
              {/* 被保險人資料 */}
              {
                INSURED_DATA && (
                  <InsuredInfo
                    InsTypeId={this.state.insTypeId}
                    DATA={INSURED_DATA.DATA}
                  />
                )
              }
              {/* 航班資訊 */}
              {/* {
                FLIGHT_DATA && (
                  <FlightInfo {...FLIGHT_DATA} />
                )
              } */}
              {/* 付款資訊 */}
              {
                PAYMENT_DATA && (
                  <PaymentInfo {...PAYMENT_DATA} />
                )
              }
            </div>
            <div className="policy-detail__controls">
              <button type="button" className="policy-detail__btn" onClick={() => this.props.history.push(RouterSettings.MemberCenter.PolicyInquiry)}>{commonService.getNameByLng(this.props.resources, 'TID_Back_to_policy_query')}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    resources: state.resources
  };
};

export default connect(mapStateToProps)(PolicyDetailTravel);
